let ctx;

const getCtx = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const play = (notes, type, step, label) => {
  try {
    const c = getCtx();
    notes.forEach((freq, i) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      const t = c.currentTime + i * step;
      osc.type = type;
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.3, t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + step - 0.01);
      osc.connect(gain).connect(c.destination);
      osc.start(t);
      osc.stop(t + step);
    });
    window.__lastBeep = label;
  } catch {}
};

export const unlockAudio = () => {
  try { getCtx(); } catch {}
};

export const beep = (ok = true) => (ok ? play([880, 1320], "sine", 0.12, "success") : play([220, 180], "square", 0.12, "error"));

export const orderChime = () => play([660, 880, 1100, 880, 1100], "triangle", 0.16, "new-order");
